(function inbentaAnswer() {
  const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
  const compName = "inbenta-answer";
  const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }

  const inbentaApi = GlobalSite.checkDependency("GlobalSite.inbentaApi");
  const searchEngineUi = GlobalSite.checkDependency("GlobalSite.searchEngineUi");
  const scrollSearchbar = GlobalSite.checkDependency("GlobalSite.scrollSearchbar");
  const getUrlParam = GlobalSite.checkDependency("GlobalSite.getUrlParam");

  $(async () => {
    const buttons = $(".inbenta-question-rating button");
    const textarea = $(".inbenta-question-rating textarea");
    const firstStep = $(".inbenta-question-rating--first-step");
    const secondStep = $(".inbenta-question-rating--second-step");
    const finalStep = $(".inbenta-question-rating--final-step");
    const isTracking = inbentaApi.isTracking();

    secondStep.hide();
    finalStep.hide();

        buttons.on("click", (e) => {
      const el = $(e.target);

      const source = el.data("source");
      const trackingType = el.data("trackingType");
      const trackingValue = el.data("trackingValue");
      const buttonEvents = {
        Oui: {
          hide: firstStep,
          show: finalStep,
        },
        Non: {
          hide: firstStep,
          show: secondStep,
        },
        Envoyer: {
          hide: secondStep,
          show: finalStep,
        },
      };

      if (!source || !trackingType || !trackingValue || !isTracking) {
        return;
      }

      buttonEvents[el[0].value].hide.hide();
      buttonEvents[el[0].value].show.show();

      inbentaApi.sendTrackingEvents(
        {
          type: trackingType,
          data: { code: trackingValue, value: el.data("value"), comment: textarea.val() },
        },
        source,
      );
    });

    textarea.on("keyup", (e) => {
      if (e.target.value.length === 0) {
        textarea.parent().find("button").prop("disabled", true);
      } else if (e.target.value.length >= 1) {
        textarea.parent().find("button").prop("disabled", false);
      }
    });

    const searchInput = $(".inbenta-faq__wrapper .search");
    const submitInput = $(".inbenta-faq__wrapper .submit");
    const deleteButton = $(".inbenta-faq__wrapper .delete-btn");
    const autocomplete = $(".inbenta-autocomplete");

    const inbentaAuth = await inbentaApi.auth();

    const redirectionUrl = document.querySelector(".inbenta-answer").getAttribute("data-redirection-url");

    inbentaAuth && searchEngineUi(
      [searchInput, submitInput, deleteButton, autocomplete],
      "faq",
      undefined,
      true,
      redirectionUrl
    );

    const goBackBtn = document.querySelector(".inbenta-answer__go-back");
    const urlParam = getUrlParam("q");

    if (goBackBtn && redirectionUrl) {
      goBackBtn.setAttribute("href", `${redirectionUrl}${urlParam ? `?q=${urlParam}` : ''}`);
    }

    scrollSearchbar({
      classNamePrefix: "inbenta-faq",
      offsetInput: 60
    })
  });
})();
